export var CountryCodes = /*#__PURE__*/ function(CountryCodes) {
    CountryCodes["US"] = "US";
    CountryCodes["CA"] = "CA";
    return CountryCodes;
}({});
export var CountryNames = /*#__PURE__*/ function(CountryNames) {
    CountryNames["US"] = "United States";
    CountryNames["CA"] = "Canada";
    return CountryNames;
}({});
export var UsStates = /*#__PURE__*/ function(UsStates) {
    UsStates["AL"] = "Alabama";
    UsStates["AK"] = "Alaska";
    UsStates["AS"] = "American Samoa";
    UsStates["AZ"] = "Arizona";
    UsStates["AR"] = "Arkansas";
    UsStates["CA"] = "California";
    UsStates["CO"] = "Colorado";
    UsStates["CT"] = "Connecticut";
    UsStates["DE"] = "Delaware";
    UsStates["DC"] = "District Of Columbia";
    UsStates["FM"] = "Federated States Of Micronesia";
    UsStates["FL"] = "Florida";
    UsStates["GA"] = "Georgia";
    UsStates["GU"] = "Guam";
    UsStates["HI"] = "Hawaii";
    UsStates["ID"] = "Idaho";
    UsStates["IL"] = "Illinois";
    UsStates["IN"] = "Indiana";
    UsStates["IA"] = "Iowa";
    UsStates["KS"] = "Kansas";
    UsStates["KY"] = "Kentucky";
    UsStates["LA"] = "Louisiana";
    UsStates["ME"] = "Maine";
    UsStates["MH"] = "Marshall Islands";
    UsStates["MD"] = "Maryland";
    UsStates["MA"] = "Massachusetts";
    UsStates["MI"] = "Michigan";
    UsStates["MN"] = "Minnesota";
    UsStates["MS"] = "Mississippi";
    UsStates["MO"] = "Missouri";
    UsStates["MT"] = "Montana";
    UsStates["NE"] = "Nebraska";
    UsStates["NV"] = "Nevada";
    UsStates["NH"] = "New Hampshire";
    UsStates["NJ"] = "New Jersey";
    UsStates["NM"] = "New Mexico";
    UsStates["NY"] = "New York";
    UsStates["NC"] = "North Carolina";
    UsStates["ND"] = "North Dakota";
    UsStates["MP"] = "Northern Mariana Islands";
    UsStates["OH"] = "Ohio";
    UsStates["OK"] = "Oklahoma";
    UsStates["OR"] = "Oregon";
    UsStates["PW"] = "Palau";
    UsStates["PA"] = "Pennsylvania";
    UsStates["PR"] = "Puerto Rico";
    UsStates["RI"] = "Rhode Island";
    UsStates["SC"] = "South Carolina";
    UsStates["SD"] = "South Dakota";
    UsStates["TN"] = "Tennessee";
    UsStates["TX"] = "Texas";
    UsStates["UT"] = "Utah";
    UsStates["VT"] = "Vermont";
    UsStates["VI"] = "Virgin Islands";
    UsStates["VA"] = "Virginia";
    UsStates["WA"] = "Washington";
    UsStates["WV"] = "West Virginia";
    UsStates["WI"] = "Wisconsin";
    UsStates["WY"] = "Wyoming";
    return UsStates;
}({});
export var CaProvinces = /*#__PURE__*/ function(CaProvinces) {
    CaProvinces["AB"] = "Alberta";
    CaProvinces["BC"] = "British Columbia";
    CaProvinces["MB"] = "Manitoba";
    CaProvinces["NB"] = "New Brunswick";
    CaProvinces["NL"] = "Newfoundland and Labrador";
    CaProvinces["NS"] = "Nova Scotia";
    CaProvinces["NT"] = "Northwest Territories";
    CaProvinces["NU"] = "Nunavut";
    CaProvinces["ON"] = "Ontario";
    CaProvinces["PE"] = "Prince Edward Island";
    CaProvinces["QC"] = "Qu\xe9bec";
    CaProvinces["SK"] = "Saskatchewan";
    CaProvinces["YT"] = "Yukon";
    return CaProvinces;
}({});
export var LocationFields = /*#__PURE__*/ function(LocationFields) {
    LocationFields["addressLine1"] = "addressLine1";
    LocationFields["addressLine2"] = "addressLine2";
    LocationFields["city"] = "city";
    LocationFields["state"] = "state";
    LocationFields["stateCode"] = "stateCode";
    LocationFields["countryCode"] = "countryCode";
    LocationFields["country"] = "country";
    LocationFields["latitude"] = "latitude";
    LocationFields["longitude"] = "longitude";
    LocationFields["postalCode"] = "postalCode";
    return LocationFields;
}({});
export var InjectableServices = /*#__PURE__*/ function(InjectableServices) {
    InjectableServices["AppService"] = "AppService";
    InjectableServices["AuthService"] = "AuthService";
    InjectableServices["FboAuthService"] = "FboAuthService";
    InjectableServices["AvatarService"] = "AvatarService";
    InjectableServices["AvatarCollaboratorService"] = "AvatarCollaboratorService";
    InjectableServices["AvatarSuggestedCollaboratorService"] = "AvatarSuggestedCollaboratorService";
    InjectableServices["AvatarTalentPoolCandidateService"] = "AvatarTalentPoolCandidateService";
    InjectableServices["AvatarEmployerCandidatesService"] = "AvatarEmployerCandidatesService";
    InjectableServices["AvatarCandidatesListService"] = "AvatarCandidatesListService";
    InjectableServices["AvatarTimelineService"] = "AvatarTimelineService";
    InjectableServices["AvatarResumeService"] = "AvatarResumeService";
    InjectableServices["SubmissionAvatarService"] = "SubmissionAvatarService";
    InjectableServices["CandidateOnePagerService"] = "CandidateOnePagerService";
    InjectableServices["CandidateCartService"] = "CandidateCartService";
    InjectableServices["ClientService"] = "ClientService";
    InjectableServices["ClientJobService"] = "ClientJobService";
    InjectableServices["ChatService"] = "ChatService";
    InjectableServices["CandidateAtsService"] = "CandidateAtsService";
    InjectableServices["ContractorProfileService"] = "ContractorProfileService";
    InjectableServices["FileActionService"] = "FileActionService";
    InjectableServices["HideNavbarService"] = "HideNavbarService";
    InjectableServices["InterviewCopilotService"] = "InterviewCopilotService";
    InjectableServices["JobAiService"] = "JobAiService";
    InjectableServices["LanguageCopilotService"] = "LanguageCopilotService";
    InjectableServices["MfaService"] = "MfaService";
    InjectableServices["OnboardingService"] = "OnboardingService";
    InjectableServices["PerformanceTrackingService"] = "PerformanceTrackingService";
    InjectableServices["UtilsService"] = "UtilsService";
    InjectableServices["UserService"] = "UserService";
    InjectableServices["ThemeService"] = "ThemeService";
    InjectableServices["RestTrackingService"] = "RestTrackingService";
    InjectableServices["NotesService"] = "NotesService";
    return InjectableServices;
}({});
export var InjectableStores = /*#__PURE__*/ function(InjectableStores) {
    InjectableStores["AuthStore"] = "AuthStore";
    InjectableStores["ClientJobStore"] = "ClientJobStore";
    InjectableStores["GuestUserStore"] = "GuestUserStore";
    InjectableStores["MfaStore"] = "MfaStore";
    InjectableStores["NotesStore"] = "NotesStore";
    InjectableStores["PageHeaderStore"] = "PageHeaderStore";
    InjectableStores["UserStore"] = "UserStore";
    return InjectableStores;
}({});
export var InjectableConfig = /*#__PURE__*/ function(InjectableConfig) {
    InjectableConfig["AppType"] = "AppType";
    InjectableConfig["Axios"] = "Axios";
    InjectableConfig["BuildMap"] = "BuildMap";
    InjectableConfig["CognitoUserPool"] = "CognitoUserPool";
    InjectableConfig["Environment"] = "Environment";
    InjectableConfig["FboAxios"] = "FboAxios";
    InjectableConfig["I18n"] = "I18n";
    InjectableConfig["MfeType"] = "MfeType";
    InjectableConfig["Rollbar"] = "Rollbar";
    return InjectableConfig;
}({});
export var InjectableContexts = /*#__PURE__*/ function(InjectableContexts) {
    InjectableContexts["Alert"] = "Alert";
    InjectableContexts["RestTracking"] = "RestTracking";
    InjectableContexts["MixPanelTracking"] = "MixPanelTracking";
    return InjectableContexts;
}({});
